import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { useCan } from "components";
import { CreateEditKeyLockerModal, KeyLockersTable, useKeyLockerWarning } from "modules/KeyLockersDashboard/components";
import "modules/KeyLockersDashboard/KeyLockerDashboard.scss";

export const KeyLockersDashboard = () => {
  const [showCreateKeyLockerModal, setShowCreateKeyLockerModal] = useState(false);

  useKeyLockerWarning();
  const canCreateKeyLocker = useCan("create", "keylockers");

  return (
    <div className="KeyLockerDashboard">
      <div className="toolbar">
        <Button basic icon className="add-btn" disabled={!canCreateKeyLocker} onClick={() => setShowCreateKeyLockerModal(true)}>
          <Icon className="plus" />
        </Button>
      </div>
      <KeyLockersTable />
      <CreateEditKeyLockerModal isOpen={showCreateKeyLockerModal} onClose={() => setShowCreateKeyLockerModal(false)} />
    </div>
  );
};
